import EnvironmentGuard from 'src/components/EnvironmentGuard';
import ManagedBasePoliciesList from './ManagedBasePoliciesList';

const ManagedPolicies = () => (
  <EnvironmentGuard>
    <ManagedBasePoliciesList />
  </EnvironmentGuard>
);

export default ManagedPolicies;
